import { render, staticRenderFns } from "./NinjaFormsListRadio.vue?vue&type=template&id=0cb0ff1d&"
import script from "./NinjaFormsListRadio.vue?vue&type=script&lang=js&"
export * from "./NinjaFormsListRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports